import * as Slot from '@/ui/primitives/slot'
import type { TextRef } from '@/ui/primitives/types'
import { cn } from '@/ui/utils'
import { forwardRef } from 'react'
import { Text as RNText } from 'react-native'
import { typographyStyles } from './typography.styles'
import type { TypographyProps } from './typography.types'

const Text = forwardRef<TextRef, TypographyProps>(
	(
		{
			className,
			asChild = false,
			size = 'body1',
			weight = 'book',
			tone = 'ink',
			underlined,
			spacing = 'normal',
			...props
		},
		ref
	) => {
		const Component = asChild ? Slot.Text : RNText

		return (
			<Component
				className={cn(
					typographyStyles({ size, weight, tone, underlined, spacing }),
					className
				)}
				ref={ref}
				maxFontSizeMultiplier={1.5}
				{...props}
			/>
		)
	}
)

Text.displayName = 'Text'

export { Text }
